<template>
  <div
    class="p-3 bg-white card border-top-start-radius-0 border-top-end-radius-0 avaliacao-card"
    data-animation="FadeIn"
  >
    <div>
      <div class="row mt-3">
        <div class="col-12">
          <h6 class="carga-title">{{ $t('loadTest') }}</h6>
        </div>
        <div class="form-group col-12 col-md-4">
          <label for="" class="required">{{ $t('description') }}</label>
          <input class="form-control" type="text" v-model="state.testeCarga.description" />
        </div>
        <div class="form-group col-12 col-md-2">
          <label for="" class="required">{{ $t('testNumber') }}</label>
          <input
            class="form-control"
            type="number"
            disabled
            v-model="state.testeCarga.test_number"
          />
        </div>
      </div>
      <hr />
      <div class="row mt-3">
        <div class="col-12 d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">
            {{ $t('exercises') }}
            <button class="btn-chart-toggle-sm ms-2" @click="showChart = !showChart" title="Ver gráfico" v-if="state.exerciciosTesteCarga.length > 0">
              <i class="fas fa-chart-bar"></i>
            </button>
          </h5>
          <span class="badge bg-gradient-info text-white px-3 py-2" style="font-size: 0.95rem;">
            Total: {{ state.exerciciosTesteCarga.length }} exercício(s)
          </span>
        </div>
        <div class="form-group col-12 col-sm-3 mt-sm-0">
          <label class="required">{{ $t('modality') }}</label>
          <select
            class="form-control custom-select carga-select"
            name="modalidade"
            id="select-modalidade"
            v-model="state.modalidadeSelecionadaId"
            @change="buscarGrupos()"
          >
            <option value="">{{ $t('selectModality') }}</option>
            <option v-for="(item, index) in state.modalidades" :key="index" :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="form-group col-12 col-sm-3 mt-sm-0">
          <label class="required">{{ $t('group') }}</label>
          <select
            class="form-control custom-select carga-select"
            name="grupo"
            required
            v-model="state.grupoSelecionadoId"
            @change="buscarExercicios()"
          >
            <option v-for="(item, index) in state.grupos" :key="index" :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="form-group col-12 col-sm-4 mt-sm-0">
          <label class="required">{{ $t('exercise') }}</label>
          <select
            class="form-control custom-select carga-select"
            name="exercicio"
            required
            id="select-exercicio"
            v-model="state.exercicioSelecionadoId"
          >
            <option v-for="(item, index) in state.exercicios" :key="index" :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="col-12 col-sm-2 align-self-end">
          <button type="button" class="btn bg-gradient-secondary" @click="adicionarExercicio()">
            {{ $t('addAll') }}
          </button>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12 mb-3" v-if="state.exerciciosSelecionados.length > 0">
          <button type="button" class="btn bg-gradient-danger btn-sm" @click="apagarExerciciosSelecionados()">
            <i class="fas fa-trash me-2"></i>
            Apagar Selecionados ({{ state.exerciciosSelecionados.length }})
          </button>
        </div>
        <!-- CHART OVERLAY -->
        <div v-if="showChart" class="chart-overlay" @click.self="showChart = false">
            <div class="chart-modal">
                <div class="chart-modal-header">
                    <span><i class="fas fa-chart-bar me-2"></i>Gráfico de Carga Máxima</span>
                    <button class="btn-chart-close" @click="showChart = false"><i class="fas fa-times"></i></button>
                </div>
                <div class="chart-modal-body">
                    <canvas ref="cargaChartCanvas"></canvas>
                </div>
            </div>
        </div>

        <div class="col-12 table-responsive">
          <table class="table table-bordered carga-table">
            <thead>
              <tr
                class="font-weight-bold align-middle text-center carga-thead"
                style="font-size: 0.8rem; line-height: 1.2"
              >
                <td style="width: 40px;">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="state.selecionarTodos"
                    @change="toggleSelecionarTodos()"
                    title="Selecionar todos"
                  />
                </td>
                <td style="width: 50px;">#</td>
                <td>{{ $t('exercises') }}</td>
                <td>{{ $t('repetitions') }}</td>
                <td>{{ $t('testLoad') }}</td>
                <td>
                  {{ $t('maxLoad') }} <br />
                  ({{ $t('current') }})
                </td>
                <td>{{ $t('firstTest') }}</td>
                <td>{{ $t('previousTest') }}</td>
                <td>
                  {{ $t('diffCurrentFirst') }} <br />
                  {{ $t('current') }} / {{ $t('firstTest') }}
                </td>
                <td>
                  {{ $t('diffCurrentPrevious') }} <br />
                  {{ $t('current') }} / {{ $t('previousTest') }}
                </td>
                <td></td>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr v-for="(item, index) in state.exerciciosTesteCarga" :key="index">
                <td class="text-center">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :value="index"
                    v-model="state.exerciciosSelecionados"
                  />
                </td>
                <td class="text-center font-weight-bold">{{ index + 1 }}</td>
                <td class="text-start">{{ item.exercise.name }}</td>
                <td>
                  <select class="form-control custom-select carga-select" required v-model="item.repetitions">
                    <option v-for="number in 16" :key="number" :value="number">{{ number }}</option>
                  </select>
                </td>
                <td>
                  <input class="form-control" type="text" v-model="item.load_test" />
                </td>
                <td>
                  <span class="carga-badge">{{ cargaMaxima(item) }}</span>
                </td>
                <td>
                  {{
                    state.testeCarga.test_number == 1
                      ? cargaMaxima(item)
                      : cargaMaximaPrimeiroTeste(item.exercise_id, item.load_test)
                  }}
                </td>
                <td>
                  {{ cargaMaximaTesteAnterior(item.exercise_id, item.load_test) }}
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualPrimeiro(item))">{{ diferencialAtualPrimeiro(item) }}</span>
                </td>
                <td>
                  <span :class="diffClass(diferencialAtualAnterior(item))">{{ diferencialAtualAnterior(item) }}</span>
                </td>
                <td>
                  <span
                    class="pointer"
                    data-bs-toggle="tooltip"
                    data-bs-original-title="Deletar exercicio"
                    :title="$t('deleteExercise')"
                    data-bs-placement="top"
                    v-tooltip
                    @click="deletarExercicio(item)"
                  >
                    <i class="fas fa-trash text-secondary me-2"></i>
                    {{ $t('delete') }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12 text-end">
        <router-link to="/avaliacao-fisica">
          <button type="button" class="btn bg-gradient-secondary">Voltar</button>
        </router-link>
        <button
          type="button"
          class="ms-3 btn bg-gradient-primary"
          :disabled="salvarDisabled"
          @click.prevent="salvar"
        >
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { calcularCargaMaxima } from '@/services/cargaMaxima.service'
  import modalidadeRepository from "../../../../../services/api/modalidadeRepository"
  import grupoRepository from "../../../../../services/api/grupoRepository"
  import exercicioRepository from "../../../../../services/api/exercicioRepository"
  import testesCargaRepository from "../../../../../services/api/testesCargaRepository"
import {reactive, onMounted, ref, inject, watch, computed, nextTick} from 'vue'
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Chart from 'chart.js/auto'

export default {
  props: {
    avaliacaoIdProp: {
      type: Number,
      default: 0,
    },
    localProp: {
      type: String,
      default: '',
    },
    dataProp: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()

    watch(
      () => props.localProp,
      (newValue, oldValue) => {
        state.testeCarga.test_local = newValue
      },
    )

    watch(
      () => props.dataProp,
      (newValue, oldValue) => {
        state.testeCarga.test_date = newValue
      },
    )

    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)
      buscarModalidades()

      state.avaliacaoId = props.avaliacaoIdProp
      state.testeCarga.test_date = props.dataProp

      buscarDadosTesteDeCarga()
    })

    const mudaNumeroTeste = ref(false)

    const state = reactive({
      avaliacaoId: 0,
      testeDeCargaNovoId: 0,
      modalidadeSelecionadaId: '',
      grupoSelecionadoId: '',
      exercicioSelecionadoId: '',
      modalidades: [],
      exercicios: [{ name: '...', id: '' }],
      grupos: [{ name: '...', id: '' }],
      exerciciosTesteCarga: [],
      testeCarga: {
        description: '',
        test_number: 0,
        test_date: '',
        test_local: '',
      },
      exerciciosTesteCargaPrimeiro: [],
      exerciciosTesteCargaAnterior: [],
      exerciciosSelecionados: [], // ✅ NOVO: Array de índices dos exercícios selecionados
      selecionarTodos: false, // ✅ NOVO: Checkbox "Selecionar Todos"
    })

    const buscarDadosTesteDeCarga = async () => {
      try {
        store.commit('SET_SPLASH_SCREEN', true)

        if (state.avaliacaoId == 0) {
          await verificaNumeroTeste()
          return
        }
        let response = await testesCargaRepository.TesteCargaGetByAssessmentId(state.avaliacaoId)
        if (response.data.success && response.data.data) {
          state.testeCarga = {
            id: response.data.data.id,
            student_physical_assessment_id: response.data.data.student_physical_assessment_id,
            description: response.data.data.description,
            test_number: response.data.data.test_number,
            test_date: response.data.data.test_date.split('-').reverse().join('/'),
            test_local: response.data.data.test_local,
          }
          state.exerciciosTesteCarga = response.data.data.exercises
          buscarDadosComparativos(true)
        }
      } catch (error) {
        console.log(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const buscarModalidades = async () => {
      state.grupos = [{ name: '...', id: '' }]
      state.exercicios = [{ name: '...', id: '' }]
      try {
        store.commit('SET_SPLASH_SCREEN', true)
        let response = await modalidadeRepository.ModalidadeGet()
        if (response.data.success) {
          state.modalidades = response.data.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const buscarGrupos = async () => {
      state.exercicios = [{ name: '...', id: '' }]
      state.grupos = [{ name: '...', id: '' }]
      try {
        store.commit('SET_SPLASH_SCREEN', true)
        let response = await grupoRepository.GrupoGetByModalityId(
          parseInt(state.modalidadeSelecionadaId),
        )
        if (response.data.success) {
          state.grupos = response.data.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const buscarExercicios = async () => {
      try {
        store.commit('SET_SPLASH_SCREEN', true)
        let response = await exercicioRepository.ExercicioGetByGroupId(
          parseInt(state.grupoSelecionadoId),
        )

        if (response.data.success) {
          state.exercicios = response.data.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const adicionarExercicio = () => {
      if (!state.testeCarga.test_number || state.testeCarga.test_number === 0) {
        swal({
          title: 'Oops',
          text: 'Informe o número do treino para cadastrar um exercício!',
          icon: 'warning',
          customClass: { confirmButton: 'btn bg-gradient-success' },
          buttonsStyling: false,
        })
        return
      }
      let exercicio = state.exercicios.find((x) => x.id === parseInt(state.exercicioSelecionadoId))
      let exercicioJaCadastrado = state.exerciciosTesteCarga.find(
        (x) => x.exercise_id === parseInt(state.exercicioSelecionadoId),
      )
      if (exercicioJaCadastrado) {
        swal({
          title: 'Oops',
          text: $t('exerciseAlreadyAdded'),
          icon: 'warning',
          customClass: { confirmButton: 'btn bg-gradient-success' },
          buttonsStyling: false,
        })
        return
      }
      state.exerciciosTesteCarga.push({
        id: 0,
        exercise: { name: exercicio.name },
        exercise_id: exercicio.id,
        repetitions: 1,
        load_test: 1,
      })
    }

    async function verificaNumeroTeste() {
      const response = await testesCargaRepository.TesteCargaGetLatest()
      if (response.data.success) {
        if (response.data.data != null) {
          if (Array.isArray(response.data.data) && response.data.data.length > 0) {
            state.testeCarga.test_number = parseInt(response.data.data.test_number) + 1
          } else if (!Array.isArray(response.data.data)) {
            state.testeCarga.test_number = parseInt(response.data.data.test_number) + 1
          } else {
            state.testeCarga.test_number = 1
          }
        } else {
          state.testeCarga.test_number = 1
        }
      }
      buscarDadosComparativos(true)
    }

    const buscarDadosComparativos = async (force = false) => {
      if (mudaNumeroTeste.value || force) {
        // VERIFICA SE NAO É O PRIMEIRO TESTE
        if (state.testeCarga.test_number > 1) {
          try {
            let exerciciosPrimeiroTeste = await testesCargaRepository.ExerciciosPrimeiroTesteCargaGet()
            if (exerciciosPrimeiroTeste.data.success) {
              state.exerciciosTesteCargaPrimeiro = exerciciosPrimeiroTeste.data.data
            }

            let exerciciosTesteAnterior = await testesCargaRepository.ExerciciosByTesteCargaNumeroGet(
              state.testeCarga.test_number - 1,
            )
            if (exerciciosTesteAnterior.data.success) {
              state.exerciciosTesteCargaAnterior = exerciciosTesteAnterior.data.data
            }
          } catch (error) {
            console.error(error)
          } finally {
          }
        }
      }
    }

    async function salvar() {
      if (!validate()) return
      salvarDisabled.value = true

      let testeDeCarga = Object.assign({}, state.testeCarga)
      testeDeCarga.test_date =
        testeDeCarga.test_date != '' ? testeDeCarga.test_date.split('/').reverse().join('-') : null
      // student.phone  = this.$filters.justNumbers(state.student.phone)
      // student.cpf  = this.$filters.justNumbers(state.student.cpf)

      if (state.avaliacaoId == 0 && route.params.id && parseInt(route.params.id) > 0) {
        state.avaliacaoId = parseInt(route.params.id)
      }

      if (state.avaliacaoId == 0) {
        let exerciciosTesteCarga = state.exerciciosTesteCarga.map((item) => {
          return {
            max_load_test: cargaMaxima(item),
            load_test_id: 0,
            exercise_id: item.exercise_id,
            repetitions: item.repetitions,
            load_test: item.load_test,
          }
        })
        testeDeCarga['exercises'] = exerciciosTesteCarga
        // ADICIONE ESTE LOG PARA DEPURAR
        console.log('Enviando para salvar:', testeDeCarga)
        context.emit('salvar', testeDeCarga, 'carga')
        salvarDisabled.value = false
        //window.location.reload()
        console.log('c')
      } else {
        console.log('f')
        store.commit('SET_SPLASH_SCREEN', true)
        testeDeCarga['student_physical_assessment_id'] = state.avaliacaoId
        if (testeDeCarga.id == undefined || testeDeCarga.id == 0) {
          testesCargaRepository
            .TesteCargaPost(testeDeCarga)
            .then((response) => {
              store.commit('SET_SPLASH_SCREEN', false)
              if (response.data.success) {
                console.log('q')
                let testeCargaId = response.data.data.id
                let exerciciosTesteCarga = state.exerciciosTesteCarga.map((item) => {
                  return {
                    max_load_test: cargaMaxima(item),
                    load_test_id: testeCargaId,
                    exercise_id: item.exercise_id,
                    repetitions: item.repetitions,
                    load_test: item.load_test,
                  }
                  // item['max_load_test'] = cargaMaxima(item)
                  // item.training_plan_id = testeCargaId
                  // return item
                })
                store.commit('SET_SPLASH_SCREEN', true)
                testesCargaRepository
                  .TesteCargaExerciciosPost(exerciciosTesteCarga)
                  .then((responseExercicios) => {
                    console.log('w')
                    store.commit('SET_SPLASH_SCREEN', false)
                    if (responseExercicios.data.success) {
                      console.log('e')
                      swal({
                        title: 'Teste de carga',
                        text: 'Teste de carga atualizado com sucesso!',
                        icon: 'success',
                        customClass: {
                          confirmButton: 'btn bg-gradient-success',
                        },
                        buttonsStyling: false,
                      }).then(() => {
                        salvarDisabled.value = false
                        //router.back()
                      })
                    }
                  })
              }
            })
            .catch((error) => {
              store.commit('SET_SPLASH_SCREEN', false)
              swal({
                icon: 'error',
                title: 'Erro ao salvar teste de carga',
                text: error.message,
              })
            })
        } else {
          try {
            let response = await testesCargaRepository.TesteCargaPut(testeDeCarga.id, testeDeCarga)
            store.commit('SET_SPLASH_SCREEN', false)
            if (response.data.success) {
              let testeCargaId = testeDeCarga.id
              let exerciciosTesteCarga = state.exerciciosTesteCarga.map((item) => {
                item['load_test_id'] = testeCargaId
                item['max_load_test'] = cargaMaxima(item)
                return item
              })
              store.commit('SET_SPLASH_SCREEN', true)

              let responseExercicios = await testesCargaRepository.TesteCargaExerciciosPut(
                exerciciosTesteCarga,
              )
              store.commit('SET_SPLASH_SCREEN', false)
              if (responseExercicios.data.success) {
                swal({
                  title: 'Teste de carga',
                  text: 'Teste de carga atualizado com sucesso!',
                  icon: 'success',
                  customClass: {
                    confirmButton: 'btn bg-gradient-success',
                  },
                  buttonsStyling: false,
                })
                salvarDisabled.value = false
              }
            }
          } catch (error) {
            console.error(error)
            swal({
              title: 'Teste de carga',
              text: 'Não foi possível atualizar os registros. Contate o administrador!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            })
          } finally {
            salvarDisabled.value = false
            store.commit('SET_SPLASH_SCREEN', false)
          }
        }
      }
    }

    function deletarExercicio(item) {
      if (!item.id || item.id === 0) {
        // Exercício ainda não salvo no banco, remover diretamente
        const index = state.exerciciosTesteCarga.findIndex(
          (x) => x.exercise_id === item.exercise_id,
        )
        if (index > -1) {
          state.exerciciosTesteCarga.splice(index, 1)
        }
        return
      }

      swal({
        title: 'Tem certeza?',
        text: `Deseja deletar ${item.exercise.name}`,
        showCancelButton: true,
        confirmButtonText: 'Sim, quero deletar!',
        cancelButtonText: 'Não, cancelar!',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          deletarExercicioConfirma(item.id)
        }
      })
    }

    function deletarExercicioConfirma(id) {
      store.commit('SET_SPLASH_SCREEN', true)
      testesCargaRepository
        .TesteCargaExercicioDelete(id)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            swal({
              title: 'Removido!',
              text: 'Exercício removido com sucesso!',
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            }).then(() => {
              let exercicioIndex = state.exerciciosTesteCarga.findIndex((x) => x.exercise_id == id)

              state.exerciciosTesteCarga.splice(exercicioIndex, 1)
            })
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error(error.message)
          swal({
            icon: 'error',
            title: 'Erro ao deletar teste de carga!',
            text: error.message,
          })
        })
    }

    // #region validators

    const validate = async () => {
      const result = await v$.value.$validate()
      return result
    }

    const rulesMessages = {
      required: helpers.withMessage('Campo obrigatório', required),
    }
    const rules = {
      modalidadeSelecionadaId: { required: rulesMessages.required },
      grupoSelecionadoId: { required: rulesMessages.required },
      exercicioSelecionadoId: { required: rulesMessages.required },
    }

    const v$ = useVuelidate(rules, state)
    // #endregion

    // function calcularValoresCarga(index) {
    //   let item = state.exerciciosTesteCarga[index]
    //   item.max_load_test = cargaMaxima(item)
    //   item.diff_current_first = diferencialAtualPrimeiro(item)
    //   item.diff_current_before = diferencialAtualAnterior(item)
    // }

    function filtraExercicioCalculos(exercicioId, primeiro = true) {
      let listaExercicios = []
      listaExercicios = primeiro
        ? state.exerciciosTesteCargaPrimeiro
        : state.exerciciosTesteCargaAnterior
      if (listaExercicios.length == 0) return null
      let exercicio = listaExercicios.find((x) => x.exercise_id == exercicioId)
      return exercicio
    }

    function cargaMaxima(item) {

      return Math.round(calcularCargaMaxima(parseInt(item.repetitions), parseInt(item.load_test)))
      // if (state.testeCarga.test_number == 1) return Math.round(calcularCargaMaxima(item.repetitions, item.load_test))
      // let cargaMaximaAtual = calcularCargaMaxima(item.repetitions, item.load_test)
      // if (cargaMaximaAtual > item.max_load_test) return Math.round(cargaMaximaAtual)
      // return Math.round(item.max_load_test)
    }

    function cargaMaximaTesteAnterior(exercise_id, load_test) {
      if (state.testeCarga.test_number == 1) return 0
      let exercicio = filtraExercicioCalculos(exercise_id, false)
      // return exercicio.max_load_test
      return exercicio ? exercicio.max_load_test : 0
      // if (state.testeCarga.test_number == 1) return Math.round(calcularCargaMaxima(item.repetitions, item.load_test))
      // let cargaMaximaAtual = calcularCargaMaxima(item.repetitions, item.load_test)
      // if (cargaMaximaAtual > item.max_load_test) return Math.round(cargaMaximaAtual)
      // return Math.round(item.max_load_test)
    }

    function cargaMaximaPrimeiroTeste(exercise_id, load_test) {
      if (state.testeCarga.test_number == 1) return load_test
      let exercicio = filtraExercicioCalculos(exercise_id, true)

      return exercicio ? exercicio.max_load_test : 0
      // return exercicio.max_load_test

    }

    function diferencialAtualPrimeiro(item) {
      // if (item.id == '') return Math.round(item.load_test)
      // return Math.round(item.load_test - item.first_test)
      let exercicio = filtraExercicioCalculos(item.exercise_id, true)

      let cargaMaximaAtual = cargaMaxima(item)
      // return cargaMaximaAtual - exercicio.max_load_test
        if(exercicio) {
        const valor = cargaMaximaAtual - exercicio.max_load_test
        return parseFloat(valor) > 0 ? `+ ${valor}` : valor
      }
      return 0
    }

    function diferencialAtualAnterior(item) {
      // if (item.id == '') return Math.round(item.load_test)
      // return Math.round(item.load_test - item.before_load_test)
      let exercicio = filtraExercicioCalculos(item.exercise_id, false)

      let cargaMaximaAtual = cargaMaxima(item)

      //let res = exercicio ? cargaMaximaAtual - exercicio.max_load_test : 0
        if(exercicio) {
        const valor = cargaMaximaAtual - exercicio.max_load_test
        return parseFloat(valor) > 0 ? `+ ${valor}` : valor
      }
      return 0

        return res
    }

    function diffClass(value) {
      const str = String(value).replace('+', '').trim()
      const num = parseFloat(str)
      if (isNaN(num) || num === 0) return 'diff-zero'
      return num > 0 ? 'diff-positive' : 'diff-negative'
    }

    const salvarDisabled = ref(false)

    // ✅ NOVO: Função para selecionar/deselecionar todos os exercícios
    function toggleSelecionarTodos() {
      if (state.selecionarTodos) {
        // Seleciona todos os índices
        state.exerciciosSelecionados = state.exerciciosTesteCarga.map((_, index) => index)
      } else {
        // Desseleciona todos
        state.exerciciosSelecionados = []
      }
    }

    // ✅ NOVO: Função para apagar múltiplos exercícios selecionados
    function apagarExerciciosSelecionados() {
      if (state.exerciciosSelecionados.length === 0) {
        return
      }

      const quantidadeSelecionada = state.exerciciosSelecionados.length
      const exerciciosParaApagar = state.exerciciosSelecionados
        .map(index => state.exerciciosTesteCarga[index])
        .filter(item => item !== undefined)

      // Verificar se há exercícios já salvos no banco (com ID)
      const exerciciosComId = exerciciosParaApagar.filter(item => item.id && item.id !== 0)
      const exerciciosSemId = exerciciosParaApagar.filter(item => !item.id || item.id === 0)

      swal({
        title: 'Tem certeza?',
        text: `Deseja deletar ${quantidadeSelecionada} exercício(s) selecionado(s)?`,
        showCancelButton: true,
        confirmButtonText: 'Sim, quero deletar!',
        cancelButtonText: 'Não, cancelar!',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          store.commit('SET_SPLASH_SCREEN', true)

          try {
            // Deletar exercícios que estão no banco de dados
            if (exerciciosComId.length > 0) {
              const deletePromises = exerciciosComId.map(item =>
                testesCargaRepository.TesteCargaExercicioDelete(item.id)
              )
              await Promise.all(deletePromises)
            }

            // Remover todos os exercícios selecionados do array (ordenar de trás pra frente para não bagunçar os índices)
            state.exerciciosSelecionados
              .sort((a, b) => b - a)
              .forEach(index => {
                state.exerciciosTesteCarga.splice(index, 1)
              })

            store.commit('SET_SPLASH_SCREEN', false)

            swal({
              title: 'Removido!',
              text: `${quantidadeSelecionada} exercício(s) removido(s) com sucesso!`,
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            })

            // Limpar seleção
            state.exerciciosSelecionados = []
            state.selecionarTodos = false

          } catch (error) {
            store.commit('SET_SPLASH_SCREEN', false)
            console.error(error.message)
            swal({
              icon: 'error',
              title: 'Erro ao deletar exercícios!',
              text: error.message,
            })
          }
        }
      })
    }

    const showChart = ref(false)
    const cargaChartCanvas = ref(null)
    let chartInstance = null

    watch(showChart, async (val) => {
      if (val) {
        await nextTick()
        renderCargaChart()
      } else {
        if (chartInstance) {
          chartInstance.destroy()
          chartInstance = null
        }
      }
    })

    function renderCargaChart() {
      if (!cargaChartCanvas.value) return
      if (chartInstance) chartInstance.destroy()
      const ctx = cargaChartCanvas.value.getContext('2d')

      const labels = state.exerciciosTesteCarga.map(item => item.exercise.name)
      const dataAtual = state.exerciciosTesteCarga.map(item => cargaMaxima(item))
      const dataPrimeira = state.exerciciosTesteCarga.map(item => {
        if (state.testeCarga.test_number == 1) return cargaMaxima(item)
        const ex = filtraExercicioCalculos(item.exercise_id, true)
        return ex ? ex.max_load_test : 0
      })
      const dataAnterior = state.exerciciosTesteCarga.map(item => {
        const ex = filtraExercicioCalculos(item.exercise_id, false)
        return ex ? ex.max_load_test : 0
      })

      chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            { label: 'Atual', data: dataAtual, backgroundColor: '#F7941D', borderColor: '#F7941D', borderWidth: 2, borderRadius: 5 },
            { label: 'Primeiro Teste', data: dataPrimeira, backgroundColor: '#2D3A7C', borderColor: '#2D3A7C', borderWidth: 2, borderRadius: 5 },
            { label: 'Teste Anterior', data: dataAnterior, backgroundColor: '#7B8ABF', borderColor: '#7B8ABF', borderWidth: 2, borderRadius: 5 }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true, position: 'top', labels: { font: { size: 12, weight: 'bold' }, padding: 14, usePointStyle: true, pointStyle: 'circle' } },
            tooltip: {
              backgroundColor: '#2D3A7C',
              cornerRadius: 8,
              padding: 10,
              callbacks: {
                label: function(context) {
                  return context.dataset.label + ': ' + context.parsed.y + ' kg'
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              grid: { color: 'rgba(45,58,124,0.08)' },
              ticks: { font: { size: 11 }, color: '#344767', callback: function(v) { return v + ' kg' } }
            },
            x: { grid: { display: false }, ticks: { font: { size: 9, weight: 'bold' }, color: '#2D3A7C', maxRotation: 45, minRotation: 20 } }
          }
        }
      })
    }

    return {
      state,
      salvar,
      v$,
      buscarGrupos,
      buscarExercicios,
      adicionarExercicio,
      cargaMaxima,
      diferencialAtualPrimeiro,
      diferencialAtualAnterior,
      buscarDadosComparativos,
      mudaNumeroTeste,
      cargaMaximaPrimeiroTeste,
      cargaMaximaTesteAnterior,
      deletarExercicio,
      salvarDisabled,
      diffClass,
      toggleSelecionarTodos,
      apagarExerciciosSelecionados,
      showChart,
      cargaChartCanvas,
    }
  },
}
</script>

<style scoped>
.avaliacao-card {
  border: 1px solid #d0d5e0;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.carga-title {
  color: #2D3A7C;
  font-weight: 700;
  font-size: 1.05rem;
  border-left: 4px solid #F7941D;
  padding-left: 12px;
}
.carga-table thead td,
.carga-table thead th {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%) !important;
  color: #fff !important;
  font-weight: 700;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 10px 8px;
  border-color: #354585 !important;
}
.carga-table tbody td {
  padding: 8px;
  vertical-align: middle;
  color: #344767;
  font-size: 0.85rem;
}
.carga-table tbody tr:nth-child(even) {
  background: #f0f2f7;
}
.carga-table tbody tr:hover {
  background: #ebeff5;
}
.carga-table .form-control {
  border: 1.5px solid #d2d6dc;
  border-radius: 6px;
  font-weight: 600;
  color: #344767;
  text-align: center;
  transition: border-color 0.2s;
}
.carga-table .form-control:focus {
  border-color: #F7941D;
  box-shadow: 0 0 0 2px rgba(247, 148, 29, 0.2);
}
.carga-badge {
  display: inline-block;
  background: #F7941D;
  color: #fff;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 3px 12px;
  border-radius: 6px;
  min-width: 50px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(247, 148, 29, 0.25);
}
.carga-select {
  border: 1.5px solid #d2d6dc !important;
  border-radius: 8px !important;
  font-size: 0.9rem;
  color: #344767;
  transition: border-color 0.2s;
}
.carga-select:focus {
  border-color: #F7941D !important;
  box-shadow: 0 0 0 3px rgba(247, 148, 29, 0.15) !important;
}
.diff-positive {
  color: #2dce89;
  font-weight: 700;
}
.diff-negative {
  color: #f5365c;
  font-weight: 700;
}
.diff-zero {
  color: #8392ab;
  font-weight: 500;
}
/* Estilo para os checkboxes com bordinha */
.form-check-input {
  width: 20px;
  height: 20px;
  border: 2px solid #2D3A7C !important;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.form-check-input:hover {
  border-color: #1E2A6C !important;
  box-shadow: 0 0 0 3px rgba(45, 58, 124, 0.15);
}
.form-check-input:checked {
  background-color: #F7941D !important;
  border-color: #F7941D !important;
  box-shadow: 0 0 0 3px rgba(247, 148, 29, 0.25);
}
.form-check-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(45, 58, 124, 0.2);
}
/* Chart button inline */
.btn-chart-toggle-sm {
  background: #F7941D;
  border: none;
  color: #fff;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  vertical-align: middle;
  box-shadow: 0 2px 6px rgba(247,148,29,0.3);
}
.btn-chart-toggle-sm:hover {
  background: #e5850f;
  transform: scale(1.1);
}
/* Chart overlay/modal */
.chart-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
}
.chart-modal {
  background: #fff;
  border-radius: 16px;
  width: 92%;
  max-width: 900px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  overflow: hidden;
  animation: chartSlideIn 0.3s ease;
}
@keyframes chartSlideIn {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
.chart-modal-header {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%);
  color: #fff;
  padding: 14px 20px;
  font-weight: 700;
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-chart-close {
  background: rgba(255,255,255,0.15);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.btn-chart-close:hover {
  background: #F7941D;
}
.chart-modal-body {
  padding: 24px;
  height: 420px;
}
</style>